/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var scW = $(window).width();

var is_rtl = false;
if ($("body").data('direction') == 'rtl') {
  is_rtl = true;
}

if ($(window).width() > 768) {
  if($('.collections-wrapper').length && typeof lightSlider) {
    $('.collections-wrapper').lightSlider({
      gallery: false,
      item: scW > 768 ? 3 : 1,
      slideMargin: 0,
      speed: 500,
      rtl: is_rtl,
      auto: false,
      controls: true,
      loop: false,
      slideMargin: scW > 768 ? 20 : 0,
      enableDrag: true,
      onBeforeSlide: function (a, b) {
        var current_slide = a.getCurrentSlideCount();
        var total_slide = a.getTotalSlideCount();
        
        if (current_slide == 1) {
          $(".slider_arrow_wrapper .slide_arrow.slide_prev").fadeOut();
        }
        else {
          $(".slider_arrow_wrapper .slide_arrow.slide_prev").fadeIn();
        }
        if ((total_slide - 2) == current_slide) {
          $(".slider_arrow_wrapper .slide_arrow.slide_next").fadeOut();
        }
        else {
          $(".slider_arrow_wrapper .slide_arrow.slide_next").fadeIn();
        }
      }
    });
  }
}

if($('.videos-content').length && typeof lightSlider) {
  $('.videos-content').lightSlider({
    gallery: false,
    item: scW > 768 ? 3 : 1,
    slideMargin: 0,
    speed: 500,
    auto: false,
    controls: false,
    loop: false,
    slideMargin: scW > 768 ? 20 : 0,
    enableDrag: true,
  });
}

$('.collection-title-item').click(function () {
  $('.collection-title-item.is-active').removeClass('is-active');
  $(this).addClass('is-active');
  $('.collection-item-content.is-visible').removeClass('is-visible');
  $('.collection-content-' + $(this).attr('data-id')).addClass('is-visible');
});

$('.video-item').click(function () {
  $('#video-popup .popup-video').attr('src', $(this).attr('video-url') + '?autoplay=1&mute=1');
  $('#video-popup').addClass('is-visible');
});

$('#video-popup .close').click(function () {
  $('#video-popup .popup-video').attr('src', '');
  $('#video-popup').removeClass('is-visible');
});

// console.log($('.bc-sf-filter-option-block:nth-child(1)').html());
// $('.bc-sf-filter-option-block:nth-child(1)').after('<p class="card__title--small heading filter-heading-wrapper shop-by-heading"><span class="filter-heading">Shop By<span></span></span></p>');


$(document).on('click', '.faq__question', function () {
  const target = $(this);
  if (target.attr('aria-expanded') == 'true') {
    $(this).removeClass('faq__question');
    const openedQuestion = $('.faq__question[aria-expanded=true]');
    openedQuestion.trigger('click');
    $(this).addClass('faq__question');
  }
});


$('#col-main').addClass('container');


var miniCartDOMSubtreeModifiedRun = true;
function checkForInstallmentProduct() {
  if(miniCartDOMSubtreeModifiedRun) {
    
    miniCartDOMSubtreeModifiedRun = false;
    setTimeout(function() {
      miniCartDOMSubtreeModifiedRun = true;
    }, 1000);
    
    const target = $(this).find('.product-recommendations-wrapper');
    if (target.html() == '') {
      target.html($('.product-recommendation-section').html());
    }
    
    let showInstallmentAlert = sessionStorage.getItem("showInstallmentAlert");
    let showInstallmentCartLimitAlert = localStorage.getItem("showInstallmentCartLimitAlert");
    let haveProductWithoutInstallment = false;
    let haveProductWithInstallment = false;
    let allProductWithInstallment = false;
    
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      if (showInstallmentAlert != 'no') {
        getProductData(data.items, data.items.length);
      }

      if (!data.items.length) {
        localStorage.setItem("showInstallmentCartLimitAlert", "yes");
      } else {
        if (document.body.dataset.enableInstCartLimit === 'true') {
          checkInstallmentLimit(data);
        }
      }
    });

    function clearCheckoutButtons(buttons) {
      buttons.forEach(button => button.classList.remove('checkout-disabled-min', 'checkout-disabled-max'));
    }

    function checkInstallmentLimit(data) {
      const minLimit = +document.body.dataset.instCartMinLimit || 0;
      const maxLimit = +document.body.dataset.instCartLimit || 0;
      const minErrorMessage = document.body.dataset.instCartMinLimitMessage;
      const maxErrorMessage = document.body.dataset.instCartLimitMessage;
      const handlesArray = [];
      const checkoutButtons = document.body.querySelectorAll(".cart-recap__checkout");

      data.items.forEach(item => {
        handlesArray.push(item.handle)
      });

      const productPromises = handlesArray.map(handle =>
        fetch(window.Shopify.routes.root + 'products/' + handle +'.js')
          .then(response => {
            if (!response.ok) {
              throw new Error(`Failed to fetch product ${handle}`);
            }
            return response.json();
          })
      );

      if (handlesArray.length) {
        Promise.all(productPromises).then(items => {
          const allInstallment = items.every(item =>
            item.tags.includes('Installment') || item.tags.includes('installment')
          );

          const cartTotal = data.total_price / 100;
          let showAlert = false;
          let alertMessage = '';

          if (allInstallment) {
            document.body.classList.remove('checkout-disabled-min', 'checkout-disabled-max', 'checkout-disabled');
            clearCheckoutButtons(checkoutButtons);

            if (minLimit && cartTotal < minLimit) {
              showAlert = true;
              alertMessage = minErrorMessage;
              document.body.classList.add('checkout-disabled-min');
            } else if (maxLimit && cartTotal > maxLimit) {
              showAlert = true;
              alertMessage = maxErrorMessage;
              document.body.classList.add('checkout-disabled-max');
            }

            if (showAlert) {
              document.body.classList.add('checkout-disabled');
              
              if (localStorage.getItem("showInstallmentCartLimitAlert") !== "no") {
                localStorage.setItem("showInstallmentCartLimitAlert", "no");
                alert(alertMessage);
              }
            } else {
              document.body.classList.remove('checkout-disabled', 'checkout-disabled-min', 'checkout-disabled-max');
              clearCheckoutButtons(checkoutButtons);
              localStorage.setItem("showInstallmentCartLimitAlert", "yes");
            }
          } else {
            document.body.classList.remove('checkout-disabled', 'checkout-disabled-min', 'checkout-disabled-max');
            clearCheckoutButtons(checkoutButtons);
            localStorage.setItem("showInstallmentCartLimitAlert", "yes");
          }
        });
      } else {
        document.body.classList.remove('checkout-disabled', 'checkout-disabled-min', 'checkout-disabled-max');
        clearCheckoutButtons(checkoutButtons);
        localStorage.setItem("showInstallmentCartLimitAlert", "yes");
      }
    }

    function getProductData(handlesArray, totalLength) {
      let prodData = handlesArray[0];
      if(prodData) {
        let handle = prodData.handle;
        fetch(window.Shopify.routes.root + 'products/' + handle +'.js')
        .then(response => response.json())
        .then(data => {
          if(data.tags.includes('Installment') || data.tags.includes('installment')) {
            haveProductWithInstallment = true;
            handlesArray = [];
          } else {
            handlesArray.shift();
          }
          getProductData(handlesArray, totalLength);
        });
      } else {
        if(showInstallmentAlert != 'no' && haveProductWithInstallment && totalLength > 1) {
          if(Shopify.locale) alert("Kindly note, that you can use the Installment service in case you have only one eligible Product in your Cart.");
          else alert("يرجى ملاحظة أنه يمكنك استخدام خدمة التقسيط في حالة وجود منتج واحد مؤهل فقط في عربة التسوق الخاصة بك.");
          sessionStorage.setItem("showInstallmentAlert", "no");
        }
      }
    }
  }
}


$(document).on('click', '.product-form .qty-selector__button, .product-form__info-list .qty-selector__button', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const target = $(this);

  if (target.data('action') == 'dec-quantity') {
    const qtyInput = target.next();
    if (parseInt(qtyInput.val()) > 1) {
      qtyInput.val(parseInt(qtyInput.val()) - 1);
    }
  } else {
    var qty = Number(target.closest("form").find(".quantity-selector__value").val()) + 1;
    var max_qty = check_product_qty_total_price_limit(target, qty);

    if (max_qty == 'true') {
      const qtyInput = target.prev();
      qtyInput.val(parseInt(qtyInput.val()) + 1);
    } else {
      const qtyInput = target.prev();
      qtyInput.val(max_qty);
    }
  }
});

// STICKY QTY - PRODUCT PAGE +/-
$(document).on('click', '.sticky_addCart_button_all .qty-selector__button', function (e) {
  e.preventDefault();
  e.stopPropagation();
  const target = $(this);

  if (target.data('action') == 'dec-quantity') {
    const qtyInput = target.next();
    if (parseInt(qtyInput.val()) > 1) {
      qtyInput.val(parseInt(qtyInput.val()) - 1);
    }
  } else {
    var qty = Number(target.closest("form").find(".quantity-selector__value").val()) + 1;
    var max_qty = check_product_qty_total_price_limit(target, qty);

    if (max_qty == 'true') {
      const qtyInput = target.prev();
      qtyInput.val(parseInt(qtyInput.val()) + 1);
    } else {
      const qtyInput = target.prev();
      qtyInput.val(max_qty);
    }
  }
  var new_qty = $(this).closest(".quantity-selector").find("input.quantity-selector__value").val();
  var prod_id = $(this).closest(".quantity-selector").attr("data-prod_id");
  $("form.product-form .quantity-selector[data-prod_id='"+prod_id+"'] input.quantity-selector__value").val(new_qty).trigger('input');

  setTimeout(function () {
    $(this).closest(".quantity-selector").find("input.quantity-selector__value").val( $("form.product-form .quantity-selector[data-prod_id='"+prod_id+"'] input.quantity-selector__value").val() );
  }.bind(this), 10);
});

$(document).on('input', '.product-form .quantity-selector__value, .product-form__info-list .quantity-selector__value', function (e) {
  const target = $(this);
  var qty = Number($(this).val());
  var max_qty = check_product_qty_total_price_limit(target, qty);

  if (max_qty != 'true') {
    $(this).val(max_qty);
  }
});

// STICKY QTY - PRODUCT PAGE input
$(document).on('input', '.sticky_addCart_button_all .quantity-selector__value', function (e) {
  var new_qty = $(this).val();
  var prod_id = $(this).closest(".quantity-selector").attr("data-prod_id");
  $("form.product-form .quantity-selector[data-prod_id='"+prod_id+"'] input.quantity-selector__value").val(new_qty).trigger('input');

  setTimeout(function () {
    $(this).closest(".quantity-selector").find("input.quantity-selector__value").val( $("form.product-form .quantity-selector[data-prod_id='"+prod_id+"'] input.quantity-selector__value").val() );
  }.bind(this), 10);
});


function check_product_qty_total_price_limit(var_this, qty) {
  var this_form = var_this.closest("form");
  var price = this_form.find("select[name='id'] option:selected").attr("data-price");
  var prod_id = this_form.attr("data-prod_id");
  var variant_id = this_form.find("select[name='id'] option:selected").val();

  var cart_json = localStorage.getItem('cart_json');
  cart_json = JSON.parse(cart_json);

  var total_price_MAX = window.theme.total_price_limit * 100;
  var total_price = Number(cart_json.total_price);
  var total_price_Available = total_price_MAX - total_price;

  total_price_Available = total_price_Available / price;
  total_price_Available = Math.floor(total_price_Available);


  // check max qty 1
  var tpl__max_qty = window.theme.tpl__max_qty; 
  if ( window.theme.tpl__max_qty ) {  
    for (let i = 0; i < cart_json.items.length; i++) {
      if ( cart_json.items[i].variant_id == variant_id) {
        tpl__max_qty = tpl__max_qty - cart_json.items[i].quantity
      }
    }
  }

// check max qty 2
  if ( window.theme.tpl__max_qty && tpl__max_qty < qty ) { 
    this_form.find(".total_qty_limit_description").slideDown();
    this_form.find(".prod_quick_view_btn_all").hide();
    $(".sticky_addCart_button_all[data-prod_id='"+prod_id+"']").find(".total_qty_limit_description").slideDown();

    setTimeout(function () {
      this_form.find(".total_qty_limit_description").slideUp();
      $(".sticky_addCart_button_all[data-prod_id='"+prod_id+"']").find(".total_qty_limit_description").slideUp();
      this_form.find(".prod_quick_view_btn_all").show();
    }, 3000);
    if ( tpl__max_qty <= 0 ) {
      tpl__max_qty = 1;
    }
    return tpl__max_qty;


// check max total price
  } else if (total_price_Available < qty) {
    if (total_price_Available < 1) {
      total_price_Available = 1;
    }
    this_form.find(".total_price_limit_description").slideDown();
    this_form.find(".prod_quick_view_btn_all").hide();
    $(".sticky_addCart_button_all[data-prod_id='"+prod_id+"']").find(".total_price_limit_description").slideDown();

    setTimeout(function () {
      this_form.find(".total_price_limit_description").slideUp();
      $(".sticky_addCart_button_all[data-prod_id='"+prod_id+"']").find(".total_price_limit_description").slideUp();
      this_form.find(".prod_quick_view_btn_all").show();
    }, 3000);
    return total_price_Available;
  } else {
    
    return 'true';
  }
}

$(document).on('click', '.bc-sf-filter-block-title h3', function () {
  $(this).parent().toggleClass('open');
});

$(document).on('click', '.btn-notify-me', function (e) {
  // $('body').addClass('bis-popover-active');
  // $('#BIS_frame').show();
  $('.BIS_trigger').trigger('click');
});

$(document).on('click', '.mini-cart-close, span.mini-cart-overlay', function (e) {
  $('.mini-cart').attr('aria-hidden', 'true');
  $('.header__cart-toggle .icon-state__secondary').trigger('click');
});


if($.fancybox) {
  $.fancybox.defaults.btnTpl.fb = '<button data-fancybox-fb class="fancybox-button fancybox-button--fb" title="Facebook">' +
    '<svg viewBox="0 0 24 24">' +
    '<path d="M22.676 0H1.324C.594 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294h-3.13v-3.62h3.13V8.41c0-3.1 1.894-4.785 4.66-4.785 1.324 0 2.463.097 2.795.14v3.24h-1.92c-1.5 0-1.793.722-1.793 1.772v2.31h3.584l-.465 3.63h-3.12V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .594 23.408 0 22.676 0"/>' +
    '</svg>' +
    '</button>';
  
  // Create template for Twitter Button
  $.fancybox.defaults.btnTpl.tw = '<button data-fancybox-tw class="fancybox-button fancybox-button--tw" title="Twitter">' +
    '<svg viewBox="0 0 24 24">' +
    '<path d="M23.954 4.57c-.885.388-1.83.653-2.825.774 1.013-.61 1.793-1.574 2.162-2.723-.95.556-2.005.96-3.127 1.185-.896-.96-2.173-1.56-3.59-1.56-2.718 0-4.92 2.204-4.92 4.918 0 .39.044.765.126 1.124C7.69 8.094 4.067 6.13 1.64 3.16c-.427.723-.666 1.562-.666 2.476 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.06c0 2.386 1.693 4.375 3.946 4.828-.413.11-.85.17-1.296.17-.314 0-.615-.03-.916-.085.63 1.952 2.445 3.376 4.604 3.416-1.68 1.32-3.81 2.105-6.102 2.105-.39 0-.78-.022-1.17-.066 2.19 1.394 4.768 2.21 7.557 2.21 9.054 0 14-7.497 14-13.987 0-.21 0-.42-.016-.63.962-.69 1.8-1.56 2.46-2.548l-.046-.02z"/>' +
    '</svg>' +
    '</button>';
  
  $.fancybox.defaults.btnTpl.wapp = '<button data-fancybox-wapp class="fancybox-button fancybox-button--wapp" title="Whatsapp">' +
    '<svg viewBox="0 0 512 512">' +
    '<path d="m256 0c-140.609375 0-256 115.390625-256 256 0 46.40625 12.511719 91.582031 36.238281 131.105469l-36.238281 124.894531 124.894531-36.238281c39.523438 23.726562 84.699219 36.238281 131.105469 36.238281 140.609375 0 256-115.390625 256-256s-115.390625-256-256-256zm160.054688 364.167969-11.910157 11.910156c-16.851562 16.851563-55.605469 15.515625-80.507812 10.707031-82.800781-15.992187-179.335938-109.5625-197.953125-190.59375-9.21875-40.140625-4.128906-75.039062 9.183594-88.355468l11.910156-11.910157c6.574218-6.570312 17.253906-6.5625 23.820312 0l47.648438 47.652344c3.179687 3.179687 4.921875 7.394531 4.921875 11.90625s-1.742188 8.730469-4.921875 11.898437l-11.90625 11.921876c-13.125 13.15625-13.125 34.527343 0 47.652343l78.683594 77.648438c13.164062 13.164062 34.46875 13.179687 47.652343 0l11.910157-11.90625c6.148437-6.183594 17.632812-6.203125 23.832031 0l47.636719 47.636719c6.46875 6.441406 6.714843 17.113281 0 23.832031zm0 0"/>' +
    '</svg>' +
    '</button>';
  
  $.fancybox.defaults.btnTpl.email = '<button data-fancybox-email class="fancybox-button fancybox-button--email" title="Email">' +
    '<svg viewBox="0 0 512 512">' +
    '<path d="M10.688,95.156C80.958,154.667,204.26,259.365,240.5,292.01c4.865,4.406,10.083,6.646,15.5,6.646 c5.406,0,10.615-2.219,15.469-6.604c36.271-32.677,159.573-137.385,229.844-196.896c4.375-3.698,5.042-10.198,1.5-14.719 C494.625,69.99,482.417,64,469.333,64H42.667c-13.083,0-25.292,5.99-33.479,16.438C5.646,84.958,6.313,91.458,10.688,95.156z"/>' +
    '<path d="M505.813,127.406c-3.781-1.76-8.229-1.146-11.375,1.542c-46.021,39.01-106.656,90.552-152.385,129.885 c-2.406,2.063-3.76,5.094-3.708,8.271c0.052,3.167,1.521,6.156,4,8.135c42.49,34.031,106.521,80.844,152.76,114.115 c1.844,1.333,4.031,2.01,6.229,2.01c1.667,0,3.333-0.385,4.865-1.177c3.563-1.823,5.802-5.49,5.802-9.49V137.083 C512,132.927,509.583,129.146,505.813,127.406z"/>' +
    '<path d="M16.896,389.354c46.25-33.271,110.292-80.083,152.771-114.115c2.479-1.979,3.948-4.969,4-8.135 c0.052-3.177-1.302-6.208-3.708-8.271C124.229,219.5,63.583,167.958,17.563,128.948c-3.167-2.688-7.625-3.281-11.375-1.542 C2.417,129.146,0,132.927,0,137.083v243.615c0,4,2.24,7.667,5.802,9.49c1.531,0.792,3.198,1.177,4.865,1.177 C12.865,391.365,15.052,390.688,16.896,389.354z"/>' +
    '<path d="M498.927,418.375c-44.656-31.948-126.917-91.51-176.021-131.365c-4-3.26-9.792-3.156-13.729,0.24 c-9.635,8.406-17.698,15.49-23.417,20.635c-17.563,15.854-41.938,15.854-59.542-0.021c-5.698-5.135-13.76-12.24-23.396-20.615 c-3.906-3.417-9.708-3.521-13.719-0.24c-48.938,39.719-131.292,99.354-176.021,131.365c-2.49,1.792-4.094,4.552-4.406,7.604 c-0.302,3.052,0.708,6.083,2.802,8.333C19.552,443.01,30.927,448,42.667,448h426.667c11.74,0,23.104-4.99,31.198-13.688 c2.083-2.24,3.104-5.271,2.802-8.323C503.021,422.938,501.417,420.167,498.927,418.375z"/>' +
    '</svg>' +
    '</button>';


$(window).on('load', function () {
  $("a#fancybox").fancybox({
    loop: true,
    parentEl: '.fancybox-wrapper',
    transitionDuration: 100,
    animationDuration: 500,
    animationEffect: "fade",
    buttons: [
      'fb',
      'wapp',
      'email',
      "zoom",
      "zoom-in-out",
      "fullScreen",
      "slideShow",
      "close"
    ],
    infobar: true,
    transitionEffect: "slide",
    thumbs: {
      autoStart: false, // Display thumbnails on opening
      hideOnClose: true, // Hide thumbnail grid when closing animation starts
      parentEl: ".fancybox-container", // Container is injected into this element
      axis: "y" // Vertical (y) or horizontal (x) scrolling
    },
    clickContent: function (current, event) {
      return current.type === "image" ? "next" : false;
    }
  });
})


// $("#fancybox").fancybox({
//   loop: true,
//   parentEl: '.fancybox-wrapper',
//   transitionDuration: 100,
//   animationDuration: 500,
//   animationEffect: "fade",
//   buttons: [
//     'fb',
//     'wapp',
//     'email',
//     "zoom",
//     "zoom-in-out",
//     "fullScreen",
//     "slideShow",
//     "thumbs",
//     "close"
//   ],
//   infobar: true,
//   transitionEffect: "slide",
//   thumbs: {
//     autoStart: false, // Display thumbnails on opening
//     hideOnClose: true, // Hide thumbnail grid when closing animation starts
//     parentEl: ".fancybox-container", // Container is injected into this element
//     axis: "y" // Vertical (y) or horizontal (x) scrolling
//   },
//   clickContent: function(current, event) {
//     return current.type === "image" ? "next" : false;
//   }
// });
  
}


$(document).on('click', '.product-gallery__image', function (e) {
  //     currentSlide($(this).data('zoom-index'));
  //     $('.image-zoom-modal').css('visibility', 'visible');
  //     $('.image-zoom-modal').css('opacity', '1');
  //     $('.image-zoom-modal').show();
  //   	$("html").css('overflow', 'hidden');
});

$(document).on('click', '.image-zoom-modal .close', function () {
  //     $('.image-zoom-modal').hide();
  //     $("html").css('overflow', 'auto');
})


$(".header__action-item.header__action-item--locale").on('click', function () {
  location.href = $(this).find('span').data('href');
})

var msg_content = '';
$("textarea#contact-form-message").on('keydown', function (evt) {
  var text_count = $(this).val().length;
  if (evt.keyCode == 8) {
    text_count--;
    if (text_count == -1) {
      text_count = 0;
    }
  }
  else {
    text_count++;
  }
  if (text_count == 2000) {
    msg_content = $(this).val();
  }

  if (text_count > 2000) {
    $(this).val(msg_content);
  }
  else {
    $(".character_count dd.count").html(text_count);
  }
})

$(".card .card__title.heading").on('click', function () {
  var handle = $(this).attr('collapsed');
  if (handle == 'true') {
    $(".card .card__section.technical-specifications-section").slideDown(function () { $(this).css('display', 'inline-block') });
    $(this).attr('collapsed', 'false');
  }
  else {
    $(".card .card__section.technical-specifications-section").slideUp();
    $(this).attr('collapsed', 'true');
  }
})

$("body").on('click', 'span.body_overlay', function () {
  $(".header__mobile-nav-toggle").click();
});
$("body").on('click', '.mob_menu_close', function (e) {
  e.preventDefault();
  $(".header__mobile-nav-toggle").click();
});

$(document).ready(function () {
  $("body").on('click', '.mobile-menu__subnav-link', function (evt) {
    var target = $(this).next(".mobile-menu__nav-collapsible");
    var handle = target.attr("data-open");
    if (handle == 'false') {
      target.attr('data-open', 'true');
    }
    else {
      target.attr('data-open', 'false');
    }
  })

  $("body").on('click', 'span.body_overlay', function () {
    $(".mobile-menu__nav-collapsible[data-open='true']").attr('data-open', 'false');
  })
  $("body").on('click', '.mob_menu_close', function (e) {
    e.preventDefault();
    $(".mobile-menu__nav-collapsible[data-open='true']").attr('data-open', 'false');
  });

  $("body").on('click', 'button.mobile-menu__back-button[data-index="2"]', function () {
    $(this).parents('.mobile-menu__nav-collapsible').attr('data-open', 'false');
  })

  $('.slider_arrow_wrapper .slide_arrow.slide_next').on('click', function () {
    $(this).parents('.scroller__inner').find('.lSNext').click();
  })

  $('.slider_arrow_wrapper .slide_arrow.slide_prev').on('click', function () {
    $(this).parents('.scroller__inner').find('.lSPrev').click();
  })

  $('.accordion_content:not(.active)').hide()
  //----- click function
  $("#accordion").find(".accordion_tab:not(.no_arrow)").click(function () {
    $("#accordion").find(".accordion_tab").removeClass('active');
    $('.accordion_content').slideUp('fast');
    var selected = $(this).next('.accordion_content');
    if (selected.is(":hidden")) {
      $(this).next('.accordion_content').slideDown('fast');
      $(this).toggleClass('active');
    }
  });

  //   var _popover_handle = false;
  //   $(".header__action-list .header__action-item--account a.header__account-icon").on('click', function(){
  //     var handle = $(this).attr('aria-expanded');
  //     if(handle == 'false'){
  //       $(this).attr('aria-expanded', 'true');
  //       $(this).next('#account-popover').attr('aria-hidden', 'false');
  //       _popover_handle = true;
  //     }
  //     else {
  //       _popover_handle = false;
  //       $(this).attr('aria-expanded', 'false');
  //       $(this).next('#account-popover').attr('aria-hidden', 'true');
  //     }
  //   })


})


//
// STICKY ADD CART BUTTON
//
$(document).ready(function () {
/*
  if ($(".js_sticky_line").length) {

    var navPos, winPos;

    function refreshVar() {
      navPos = $('.js_sticky_line').offset().top + 70;
      //console.log(navPos);
    }

    refreshVar();
    $(window).resize(refreshVar);


    $(window).scroll(function () {
      if ($(window).width() < 640 && $("body").hasClass("template-product")) {

        winPos = $(window).scrollTop();

        if (winPos >= navPos) {
          if ( $(".product-form__payment-container button[type='submit']").hasClass("button--disabled") && $("button.btn-notify-me").length ) {
            var text = $("button.btn-notify-me").html();
          } else {
            var text = $(".product-form__payment-container button[type='submit']").html();
          }
          if ( text ) {
            $(".sticky_addCart_button_js").text(text);
          }
          $('body').addClass('addCart_fixed');
        } else {
          $('body').removeClass('addCart_fixed');
        }
      }
    });
  }
*/


  $("body").on("click", ".sticky_addCart_button_js", function (e) {
    e.preventDefault();

    if ( $(this).hasClass("pre_order") ) {
      $(".product-form__payment-container button.btn-notify-me[type='button']")[0].click();
    } else {
      $(".product-form__payment-container button[type='submit']")[0].click();
    }
    //$('html, body').animate({ scrollTop: $('.product-form__payment-container').offset().top - 110 }, 700);
  });

});


$("body").on("click", ".prod_mobile_writeReview_btn_a", function(e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: $('.product-block-list__item--reviews').offset().top - 75 }, 700);
//  $('.product-block-list__item--reviews').toggleClass('hide');
  setTimeout(function() {
    $(".spr-summary-actions-newreview")[0].click();
  }, 100);
});



//
// MOBILE COLLECTION SORT
//
$(document).ready(function () {
  $("body").on("click", ".value-picker__inner_js", function (e) {
    e.preventDefault();
    if ($(window).width() <= 640) {
      $("#sort-by-toggler")[0].click();
    }
  });
  if($('body').hasClass('currency-activated-true')) {
    if($('body').hasClass('currency_iqd')) {
      localStorage.setItem('js_currency', 'iqd');
      $(".mob_lvl_a_item.currency_js.iqd").addClass("active");
    }
  }
});



//
// mini cart sticky submit
//
$("body").on("click submit", ".mini_cart_bot_fix button[type='submit']", function (e) {
  e.preventDefault();
  $("#mini-cart button[type='submit']")[0].click();
});




//
// hide map info - order page
//
$(document).ready(function () {
  if ($(".address_hide_googleMap_js").length) {
    var text = $(".address_hide_googleMap_js").html();
    text = text.replace('00000<br>', '').replace('00000', '');
    text = text.replace(localStorage.getItem('ls_location') + '<br>', '');
    text = text.replace(localStorage.getItem('ls_location'), '');
    var text_arr = text.split('<br>');
    var finish_text = '';
    for (var i = 0; i < text_arr.length; i++) {
      if (text_arr[i].indexOf('http://maps.google.com/maps?q=') !== -1) {

      } else {
        if (finish_text == '') {
          finish_text = text_arr[i];
        } else {
          finish_text = finish_text + '<br>' + text_arr[i];
        }
      }
    }
    $(".address_hide_googleMap_js").html(finish_text);
  }
});


//
// cart_json
//
var cart_json = {};
jQuery(document).ready(function () {
  if ($(".cart_json").length > 0) {
    cart_json = $(".cart_json").text();
    localStorage.setItem('cart_json', cart_json);
  }
});

//
// LIMIT TOTAL PRICE
//
function limit_total_price(item_price) {
  var cart_json = localStorage.getItem('cart_json');
  cart_json = JSON.parse(cart_json);

  var total_price_MAX = window.theme.total_price_limit * 100;
  var total_price = Number(cart_json.total_price) + Number(item_price);


  if (total_price_MAX < total_price) {
    return false;
  } else {
    return true;
  }

}






// =====================================================================================================================
//   SEARCH PAGE MOBILE
// =====================================================================================================================
// FILTER
$("body").on("click", ".snize-main-panel-controls", function (e) {
  if ($(document).width() < 768) {
    $(".snize-main-panel-mobile-filters a")[0].click();
    $(".snize-product-filters-title").addClass("open");
    $(".snize-product-filters-title + .snize-product-filters-list").show();
    $("body").addClass("body_SearctDrawer_filter");
  }
});
$("body").on("click touchstart", ".SearctDrawer_Filter_js__Close, .snize-product-filters-title", function (t) {
  if ($(document).width() < 768) {
    $(".snize-close-button")[0].click();
    $("body").removeClass("body_SearctDrawer_filter");
  }
});
// SORT
$("body").on("click", ".snize-main-panel-dropdown", function (t) {
  if ($(document).width() < 768) {
    $("body").addClass("body_SearctDrawer_sort");
  }
});
$("body").on("click touchstart", ".SearctDrawer_Sort_js__Close, .snize-sortby-title", function (t) {
  if ($(document).width() < 768) {
    $("body").removeClass("body_SearctDrawer_sort");
  }
});


















// =====================================================================================================================
//   SELECT LANG and CURRENCY
// =====================================================================================================================
if (localStorage.getItem('pupup_Select_Lang_and_Currency_timer')) {
  if ( new Date(Number(localStorage.getItem('pupup_Select_Lang_and_Currency_timer'))) < new Date() ) {
    localStorage.removeItem('pupup_Select_Lang_and_Currency');
    localStorage.removeItem('pupup_Select_Lang_and_Currency_timer');
  }
}

if ($(".pupup_Select_Lang_and_Currency_ok_js__clear").length) {

}

if (localStorage.getItem('pupup_Select_Lang_and_Currency') != 'ready') {
  $(".pupup_Select_Lang_and_Currency_all").removeClass("hide");
}
$("body").on("click", ".pupup_Select_Lang_and_Currency_ok_js", function (e) {
  e.preventDefault();

  var check = true;
  if ( $(".pupup_Select_Lang_js").length && !$(".pupup_Select_Lang_js .item").hasClass("active")) {
    $(".pupup_Select_Lang_js").addClass("error");
    setTimeout(function () {
      $(".pupup_Select_Lang_js").removeClass("error");
    }, 3500);
    check = false;
  }
  if ( $(".pupup_Select_Currency_js").length && !$(".pupup_Select_Currency_js .item").hasClass("active")) {
    $(".pupup_Select_Currency_js").addClass("error");
    setTimeout(function () {
      $(".pupup_Select_Currency_js").removeClass("error");
    }, 3500);
    check = false;
  }

  if ( $(".pupup_Select_City_js").length && !$(".pupup_Select_City_js select").val() ) {
    $(".pupup_Select_City_js").addClass("error");
    setTimeout(function () {
      $(".pupup_Select_City_js").removeClass("error");
    }, 3500);
    check = false;
  }
  

  if (check) {
    localStorage.setItem('pupup_Select_Lang_and_Currency', 'ready');
    $(".pupup_Select_Lang_and_Currency_all").toggleClass("hide");

    // Currency
    if ($(".pupup_Select_Currency_js .item.active").attr("data-item") == 'iqd') {
      localStorage.setItem('js_currency', 'iqd');
      $("body").addClass("currency_iqd");
    } else {
      localStorage.removeItem('js_currency');
      $("body").removeClass("currency_iqd");
    }
    
    if ( $(".pupup_Select_City_js").length  ) {
      localStorage.setItem('js_user_city', $(".pupup_Select_City_js select").val());
    } 

    // Lang
    if ( $(".pupup_Select_Lang_js".length) ) {
      if ($(".pupup_Select_Lang_js .item.active").attr("data-item") != $("html").attr("lang")) {
        document.location.href = $(".pupup_Select_Lang_js .item.active").attr("data-href");
      }
    }
    localStorage.removeItem('pupup_Select_Lang_and_Currency_timer');
    select_lang_and_currency_Select ();
  }
});
$("body").on("click", ".mob_lvl_a_item.currency_js", function () {
  $(".mob_lvl_a_item.currency_js").removeClass("active");
  if ($(this).hasClass("usd")) {
    $("body").removeClass("currency_iqd");
    $(".mob_lvl_a_item.currency_js.usd").addClass("active");
    localStorage.removeItem('js_currency');
  } else {
    $(".mob_lvl_a_item.currency_js.iqd").addClass("active");
    $("body").addClass("currency_iqd");
    localStorage.setItem('js_currency', 'iqd');
  }
});

$(document).ready(function () {
  if($('body').hasClass('currency-activated-true')) {
    $(".mob_lvl_a_item.currency_js").removeClass("active");
    if (localStorage.getItem('js_currency') == 'iqd') {
      $("body").addClass("currency_iqd");
      $(".mob_lvl_a_item.currency_js.iqd").addClass("active");
    } else {
      $("body").removeClass("currency_iqd");
      $(".mob_lvl_a_item.currency_js.usd").addClass("active");
    }
  }
});


$("body").on("click", ".pupup_Select_Lang_and_Currency_later_js", function () {
  $(".pupup_Select_Lang_and_Currency_all").toggleClass("hide");
  var cookie_time = Number( $(".pupup_Select_Lang_and_Currency_all").attr("data-cookie_time") );
  localStorage.setItem('pupup_Select_Lang_and_Currency', 'ready');
  localStorage.setItem('pupup_Select_Lang_and_Currency_timer',  new Date().getTime()+(cookie_time*60*60*1000) );
});


$("body").on("click", ".pupup_Select_Lang_js .item", function () {
  $(".pupup_Select_Lang_js .item").removeClass("active");
  $(this).addClass("active");
});
$("body").on("click", ".pupup_Select_Currency_js .item", function () {
  $(".pupup_Select_Currency_js .item").removeClass("active");
  $(this).addClass("active");
});


$("body").on("click", ".pupup_Select_Lang_js", function () {
  $(".pupup_Select_Lang_js").removeClass("error");
});
$("body").on("click", ".pupup_Select_Currency_js", function () {
  $(".pupup_Select_Currency_js").removeClass("error");
});


// =====================================================================================================================
//   SELECT LANG and CURRENCY - header and mobile menu
// =====================================================================================================================
function select_lang_and_currency_Select () {
  var current_city = localStorage.getItem('js_user_city');
  if ( current_city != 'None' ) {
    var current_city_Name = $(".pupup_Select_City_js #i_city option[value='"+current_city+"']").val();
    if ( $("html").attr("lang") != 'en' ) {
      current_city_Name = $(".pupup_Select_City_js #i_city option[value='"+current_city+"']").attr("data-ar");
    }
  } else {
    var current_city_Name = $(".open_Select_City_js").attr("data-en");
    if ( $("html").attr("lang") != 'en' ) {
      current_city_Name = $(".open_Select_City_js").attr("data-ar");
    }
  }
  $(".open_Select_City_js").html(current_city_Name);

}
select_lang_and_currency_Select ();


$("body").on("click", ".open_Select_City_js", function() {

  // currency
  $(".pupup_Select_Currency_js .item").removeClass("active");
  
  if ( localStorage.getItem('js_currency') == 'iqd' ) {
    $(".pupup_Select_Currency_js .item[data-item='iqd']").addClass("active");
  } else {
    $(".pupup_Select_Currency_js .item[data-item='usd']").addClass("active");
  }
  // lang
  $(".pupup_Select_Lang_js .item").removeClass("active");
  if ( $("html").attr("lang") == 'en' ) {
    $(".pupup_Select_Lang_js .item[data-item='en']").addClass("active");
  } else if ( $("html").attr("lang") == 'ar' ) {
    $(".pupup_Select_Lang_js .item[data-item='ar']").addClass("active");
  } else  {
    $(".pupup_Select_Lang_js .item[data-item='ku']").addClass("active");
  }
  // city
  $(".pupup_Select_City_js #i_city option[value='"+localStorage.getItem('js_user_city')+"']").prop("selected",true);

  $(".pupup_Select_Lang_and_Currency_all").removeClass("hide");
});

//pupup_Select_Lang_and_Currency_all
//js_user_city



// =====================================================================================================================
//   ANOUNCEMENT BAR
// =====================================================================================================================

if(typeof flickity != undefined && typeof flickity != 'undefined') {
  $('.anouncementBar_items')?.flickity({
    pageDots: false,
    wrapAround: true,
    arrowShape: {
      x0: 5,
      x1: 60, y1: 55,
      x2: 70, y2: 55,
      x3: 15
    },
    autoPlay: 4500
  });
}


// =====================================================================================================================
//   STICKY HEADER
// =====================================================================================================================
$(document).ready(function () {

  var navPos, winPos;
  function refreshVar() {
    $(".enable_sticky_header").addClass("sticky_stop")
    $('#shopify-section-header').removeClass('fixed');
    $("#shopify-section-header").css("height", 'auto');

    setTimeout(function () {
      $("#shopify-section-header").css("height", $("#shopify-section-header").height());
      $(".enable_sticky_header").removeClass("sticky_stop");
    }, 500);
  }

  refreshVar();
  $(window).resize(refreshVar);

  $(window).scroll(function () {
    winPos = $(window).scrollTop();

    if (winPos >= 350 && !$(".enable_sticky_header").hasClass("sticky_stop")) {
      $('#shopify-section-header').addClass('fixed');
    } else {
      $('#shopify-section-header').removeClass('fixed');
    }
  });

});




// =====================================================================================================================
//   QUICK LINKS
// =====================================================================================================================

if(typeof flickity != undefined && typeof flickity != 'undefined') {
  $('.quick_links_items').flickity({
    freeScroll: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });
}



// =====================================================================================================================
//   PROD TIMER
// =====================================================================================================================


function secondsToDhms(seconds) {
  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor(seconds % (3600 * 24) / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = Math.floor(seconds % 60);

  if (d < 10) {
    d = '0' + d;
  }
  if (h < 10) {
    h = '0' + h;
  }
  if (m < 10) {
    m = '0' + m;
  }
  if (s < 10) {
    s = '0' + s;
  }

  return {
    d: d,
    h: h,
    m: m,
    s: s
  };
}


setInterval(function () {
  $(".prod_time_js").each(function () {
    var seconds = Number($(this).attr("data-seconds"));
    var the_time = secondsToDhms(seconds);
    $(this).find(".days").html(the_time.d);
    $(this).find(".hours").html(the_time.h);
    $(this).find(".min").html(the_time.m);
    $(this).find(".sec").html(the_time.s);

    $(this).attr("data-seconds", seconds - 1);

    if ( seconds <= 1 ) {
      $(this).closest(".product-item").remove();
    } 
  });
}, 1000);











$('.main_fp_all .main_fp_items').each(function () {
  $(this).flickity({
    //freeScroll: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });
});

// =====================================================================================================================
$("body").on("click", ".main_fp_tab a", function (e) {
  e.preventDefault();

  $(".main_fp_tab a").removeClass("active");
  $(this).addClass("active");

  var num = $(this).attr("data-tab");
  $(".main_fp_all").hide();
  $(".main_fp_all[data-tab='" + num + "']").show();

  setTimeout(function () {
    $('.main_fp_all .main_fp_items').each(function () {
      $(this).flickity('resize');
    });
  }, 11);

});







if(typeof flickity != undefined && typeof flickity != 'undefined') {
  $(".main_sbc_items").flickity({
    //freeScroll: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });
  $(".main_sbb_items").flickity({
    //freeScroll: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });
}











// =====================================================================================================================
//   BUTTON TOP SCROLL
// =====================================================================================================================
$(window).scroll(function () {
  if ($(window).scrollTop() > 600) {
    $('.top_scroll_button').fadeIn();
  } else {
    $('.top_scroll_button').fadeOut();
  }
});
$('.top_scroll_button').on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, '300');
});





//
// CHECK YOUR ORDERS - CUSTOMER
//
$("body").on("submit", ".cyo_submitForm__Customer_js", function (e) {
  e.preventDefault();
  var data = $("#contact-order_id").val().replace(/#/g, "");

  if ($(".cyo_orders_all_js .item_all[data-order_number='" + data + "']").length) {
    $(".cyo_orders_all_js .item_all[data-order_number='" + data + "']").show();
    $(".cyo_orders_all_js").fadeIn();
  } else {
    $(".cyo_orders_error_js").fadeIn();
    setTimeout(function () {
      $(".cyo_orders_error_js").fadeOut();
    }, 2500);
  }
});
$("body").on("click", ".cyo_back_js", function (e) {
  e.preventDefault();
  $(".cyo_orders_all_js .item_all").fadeOut();
  $(".cyo_orders_all_js").fadeOut();
});




// CHECK YOUR ORDERS
// GET ALL ORDERS
if ($(".cyo_orders_all_js").length) {
  $(".cyo_orders_all_js .pagination a.pagination__nav-item").each(function () {
    funk_cyo_orders_all_js($(this).attr("href"));
  });
}
function funk_cyo_orders_all_js(url) {
  jQuery.ajax({
    type: 'GET',
    url: url,
    data: {},
    complete: function (data) {
      $(".item_all_ajax").append($(".item_all_ajax", data.responseText).html());
      //jQuery('#shopify-section-sidebar #filter-1').html(jQuery("#shopify-section-sidebar #filter-1", data.responseText).html()); 
    }
  });
}



//
// CHECK YOUR ORDERS - NO CUSTOMER
//
$("body").on("submit", ".cyo_submitForm__NO_customer_js", function (e) {
  e.preventDefault();
  var order_id = $("#contact-order_id").val().replace(/#/g, "");
  var email = $("#contact-email").val();

  var var_this = $(this);
  var_this.addClass("loading");
  
  jQuery.ajax({
    type: 'GET',
    url: 'http://serg-test.site/api_JUM3a/jum3a_check_you_order.php?order_id=' + order_id + '&email=' + email,
    data: {},
    complete: function (data) {
      var_this.removeClass("loading");

      var var_data = data.responseText.trim();
      if ( var_data == "error" ) {
        $(".cyo_orders_error_js").fadeIn();
        setTimeout(function () {
          $(".cyo_orders_error_js").fadeOut();
        }, 2500);
      } else {
        $(".cyo_orders_all_js .item_all").show();
        $(".cyo_orders_all_js").fadeIn();
        $(".item_order_id").html("#"+order_id);
        $(".item_status").html(var_data);
      }

    }
  });

});






// =====================================================================================================================
//   MOBILE MENU
// =====================================================================================================================
$("body").on("click", ".mob_lvl_a_item.sub", function (e) {
  e.preventDefault();
  $(this).closest("li").find(" > ul ").slideToggle();
  $(this).toggleClass("open");
  $(this).closest("li").toggleClass("open");
});









/*
// =====================================================================================================================
//   DOWNLOAD STATEMENTS
// =====================================================================================================================
$(document).ready(function () {
  if ($(".download_stat_all").length && download_stat_data) {
    //var download_stat_data = '01,2019,https://site.com/data.xml;02,2020;03,2021;05,2021'.split(";");
    var data_arr = download_stat_data.split(";");

    for (var i = 0; i < data_arr.length; i++) {
      var data_item = data_arr[i].split(",");
      //years
      var years = data_item[1];
      var month = data_item[0];
      var link = data_item[2];
      if ($(".download_stat_all .years .item[data-id='" + years + "']").length <= 0) {
        $(".download_stat_all .years").append('<div class="item" data-id="' + years + '" style="order: ' + years + '">' + years + '</div>');
      }
      //month
      if ($(".download_stat_all .month .item[data-id='" + years + "']").length <= 0) {
        var html = '<div class="form__input-wrapper month_all" data-id="' + years + '"><div class="select-wrapper select-wrapper--primary"><svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation"><path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path></svg>';
        html += '<select class="item" data-id="' + years + '" style="order: ' + years + '"><option value="select" disabled selected>Please select a month</option><option value="01" class="hide">January</option><option value="02" class="hide">February</option><option value="03" class="hide">March</option><option value="04" class="hide">April</option><option value="05" class="hide">May</option><option value="06" class="hide">June</option><option value="07" class="hide">July</option><option value="08" class="hide">August</option><option value="09" class="hide">September</option><option value="10" class="hide">October</option><option value="11" class="hide">November</option><option value="12" class="hide">December</option></select>';
        html += '</div></div>';
        $(".download_stat_all .month").append(html);
      }
      if (month.length == 1) {
        month = '0' + month;
      }
      $(".download_stat_all .month select.item[data-id='" + years + "'] option[value='" + month + "']").removeClass("hide");
      $(".download_stat_all .month select.item[data-id='" + years + "'] option[value='" + month + "']").attr("data-url", link);
    }
  }

  $("body").on("click", ".download_stat_all .years .item", function () {
    $(".download_stat_all .years .item").removeClass("active");
    $(this).addClass("active");
    var id = $(this).attr("data-id");
    var years = id;

    $(".download_stat_all .month_all").hide();
    $(".download_stat_all .month_all[data-id='" + years + "']").show();

    $(".download_stat_all .month_all").removeClass("active");
    $(".download_stat_all .month_all[data-id='" + years + "']").addClass("active");

    setTimeout(function () {
      $(".download_stat_all .month").slideDown();
    }, 140);
  });

  $("body").on("click", ".download_stat_all .btn_js", function (e) {
    e.preventDefault();
    if ($(".download_stat_all .month_all.active").length && $(".download_stat_all .month_all.active select option:selected").val() != 'select') {
      var link = $(".download_stat_all .month_all.active select option:selected").attr("data-url");
      window.open(link);
    } else {
      $(".download_stat_all .btn_all .error").fadeIn();

      setTimeout(function () {
        $(".download_stat_all .btn_all .error").fadeOut();
      }, 3000);
    }
  });


});
*/





// =====================================================================================================================
//   change_password
// =====================================================================================================================
$(document).ready(function () {
  if (window.location.href.indexOf('change_password') !== -1) {
    $("button[data-action='toggle-login-form']")[0].click();
  }
});



// =====================================================================================================================
//   SELLER DRAWER MENU
// =====================================================================================================================
$("body").on("click", ".btn_seller_drawer_menu_open_js", function (e) {
  e.preventDefault();
  $("body").addClass("account_drawer_menu_open");
});
$("body").on("click", ".btn_seller_drawer_menu_close_js", function (e) {
  e.preventDefault();
  $("body").removeClass("account_drawer_menu_open");
});




// =====================================================================================================================
//   SELLER LASTES PRODUCT SOLD
// =====================================================================================================================
$("body").on("click", ".seller_latest_products_sold_item_open_js", function () {
  $(this).closest(".seller_orders_item").find(".seller_latest_products_sold_items").slideToggle();
  $(this).closest(".seller_orders_item").toggleClass("open");
});







// =====================================================================================================================
//   TABS
// =====================================================================================================================
$(document).ready(function () {
  $("body").on("click", ".pt_2_content_accordion h4", function () {
    $(this).closest(".item").toggleClass("open");
    $(this).closest(".item").find(".text").slideToggle();
  });


  $("body").on("click", ".pt_2_tab_title_js", function () {
    var id = $(this).attr("data-id");
    $(".pt_2_tab_text_js").hide();
    $(".pt_2_tab_text_js[data-id='" + id + "']").show();

    $(".pt_2_tab_title_js").removeClass("active");
    $(this).addClass("active");

    $(".pt_2_content_tabs_content_all").slideDown();
    $(".pt_2_content_tabs_arrow_js").removeClass("active");
  });

  $("body").on("click", ".pt_2_content_tabs_arrow_js", function () {
    $(this).toggleClass("active");
    $(".pt_2_content_tabs_content_all").slideToggle();

  });

});//end ready





// =====================================================================================================================
//   SELLER ACCOUNT
// =====================================================================================================================

//
//   /account last product list
//

$(document).ready(function () {
  if ( $(".seller_latest_products_sold_items_js").length && seller_global_Orders_list_work && seller_global_Orders_list_work.length) {
    seller_acc_last_prod_list();
  }
});

var seller_orders_Products_count = 0;
var seller_orders_count = 0;
function seller_acc_last_prod_list() {
  var ids;
  var check_i = 0;

  
  for (var i = 0; i < seller_global_Orders_list_work.length; i++) {
    if (check_i < 250) {
      if (check_i == 0) {
        ids = seller_global_Orders_list_work[check_i];
      } else {
        ids = ids + ',' + seller_global_Orders_list_work[check_i];
      }
    }
    $(".order_id_list_js[data-order_id='"+seller_global_Orders_list_work[check_i]+"']").addClass("ready");
    check_i++;
  }
  seller_global_Orders_list_work.splice(0, 250);
  

  jQuery.ajax({
    type: 'GET',
    url: 'http://serg-test.site/api_JUM3a/jum3a_get_orders.php?orders=' + ids + '&id=' + window.theme.customerId,
    data: {},
    complete: function (data) {

      product_json = JSON.parse(data.responseText);
      for (var i = 0; i < product_json.length; i++) {
        seller_global_arr[product_json[i]['id']] = product_json[i];

        
        // all separate products
        if ( product_json[i]['line_items']) {
          for (var q = 0; q < product_json[i]['line_items'].length; q++) {
            if ( product_json[i]['line_items'][q] != "false" &&  product_json[i]['line_items'][q] ) {
              product_json[i]['line_items'][q]['order_id'] = product_json[i]['id'];
              product_json[i]['line_items'][q]['order_name'] = product_json[i]['name'];
              seller_global_Items_arr[seller_orders_Products_count] = product_json[i]['line_items'][q];
              seller_orders_Products_count++;
            }
          }
        }
      }

      seller_orders_count = 0;
      for (key in seller_global_arr) {
        seller_orders_count++;
      }
      
      if ( $(".order_id_list_js_item").length <= 0 ) {
        seller_acc_last_prod_list__HTML__PRE_LOAD();
      }
      

      setTimeout(function () {
        if (seller_global_Orders_list_work.length) {
          seller_acc_last_prod_list();
          func_simplePagination_item();
          $(".seller_latest_products_sold_items__Paginations").addClass("loading");
        } else {
          // start pagination
          func_simplePagination_item();
          $(".seller_latest_products_sold_items__Paginations").removeClass("loading");
        }
      }, 2000);
    }
  });
}


function seller_acc_last_prod_list__HTML__PRE_LOAD () {
  for (var i = 0; i < seller_global_Items_arr.length; i++) {
    if ( i < 10) {
      var line_item = seller_global_Items_arr[i];
      seller_acc_last_prod_list__HTML(line_item);
    }
  }
  
  seller_img_prod_load ();
}



function seller_acc_last_prod_list__HTML(line_item) {
  var html = $("script#script_order_id_list_js").html();

  // PRODUCT_ID
  html = html.replace( /_PRODUCT_ID_/g , line_item.product_id); 
  // ORDER ID 
  html = html.replace( /_ORDER_ID_/g , line_item.order_id);
  // ORDER NAME
  html = html.replace( /_ORDER_NAME_/g ,  line_item.order_name);
  // TITLE 
  html = html.replace( /_TITLE_/g , line_item.title);
  // DATE 
  var var_date = seller_global_arr[line_item.order_id]['created_at'].split("T");
  var_date = var_date[0].split("-");
  var monthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var_date = monthNames[Number(var_date[1])] + ' ' + var_date[2] + ', ' + var_date[0];
  html = html.replace( /_DATE_/g , var_date);
  // PRICE 
  var price = '$' + line_item.price.replace(".00", '') + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((line_item.price * window.theme.additional_price_rate)) + '</span>';
  html = html.replace( /_PRICE_/g , price);
  
  $(".seller_latest_products_sold_items_js").append(html);
 
  
}



function pagination_onPageClick(pageNumber, event) {
  $('.acc_orders_list_all table.table tbody tr').remove();
  $(".simplePagination_item").remove();
  $(".seller_orders_item").remove(); 
  
  var nums = pageNumber * 10 - 10;
  
  // SELLER /account RECENT PRODUCTS
  if ( $("#script_order_id_list_js").length ) {
    for (var i = 0; i < 10; i++) {
      var line_item = seller_global_Items_arr[nums];
      if ( line_item && line_item != 'false' ) {
        seller_acc_last_prod_list__HTML(line_item);
      }
      nums++;
    }
    seller_img_prod_load ();
  }

  // SELLER OLD/NEW ORDERS
  if ( $("#script_order_id_list_2_js").length ) {
    for (var i = 0; i <= 10; i++) {
      var line_item = seller_global_Items_arr[nums];
      if ( line_item && line_item != 'false' ) {
        seller_acc_old_new_orders__HTML(line_item);
      }
      nums++;
    }
    seller_img_prod_load ();
  }
  

    
}
var item_simplePagination_item = $(".seller_latest_products_sold_items__Paginations");
function func_simplePagination_item() {
  
  if ( $(".simple-pagination").length ) {
    item_simplePagination_item.pagination('destroy');
  }
  
  if ( seller_global_Items_arr.length >= 10) {
    $('.acc_orders_list_all .table-wrapper table tfoot tr.tr-pagination').show();
    item_simplePagination_item.pagination({
      items: seller_global_Items_arr.length,
      itemsOnPage: 10,
      cssStyle: 'light-theme',
      displayedPages: 3,
      onPageClick: pagination_onPageClick
    });
  }
}



function addCommas(nStr) {
  nStr += '';
  x = nStr.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}


// =====================================================================================================================
//   SELLER ACCOUNT   -  PAGE OLD/NEW OREDERS
// =====================================================================================================================

if ( $(".seller_orders_items_js").length && seller_global_Orders_list_work && seller_global_Orders_list_work.length) {
  seller_acc_old_new_orders();
}
else $(".seller_orders_items_clear_text").show();


function seller_acc_old_new_orders() {
  
  var ids;
  var check_i = 0;
  for (var i = 0; i < seller_global_Orders_list_work.length; i++) {
    if (check_i < 250) {
      if (check_i == 0) {
        ids = seller_global_Orders_list_work[check_i];
      } else {
        ids = ids + ',' + seller_global_Orders_list_work[check_i];
      }
    }
    $(".order_id_list_js[data-order_id='"+seller_global_Orders_list_work[check_i]+"']").addClass("ready");
    check_i++;
  }
  seller_global_Orders_list_work.splice(0, 250);

  
  jQuery.ajax({
    type: 'GET',
    url: 'http://serg-test.site/api_JUM3a/jum3a_get_orders.php?orders=' + ids + '&id=' + window.theme.customerId + '&status=shipped', 
    data: {},
    complete: function (data) {
      
      if(data.responseText == undefined) return;

      
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }
      function replaceAll(str, find, replace) {
        return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
      }
      data.responseText = replaceAll(data.responseText, 'Notice: Undefined index: _product_id in /home/v/verstab6/serg-test.site/public_html/api_JUM3a/jum3a_get_orders.php on line 88', '').trim();

      
      product_json = JSON.parse(data.responseText);
      
      // DELETE HIDE ORDERS
      for (var i = 0; i < product_json.length; i++) {
        var check_line_items = false;
        if ( product_json[i] != "false" ) {
          for (var q = 0; q < product_json[i]['line_items'].length; q++) {
            if ( product_json[i]['line_items'][q] != 'false' ) {
              check_line_items = true;
            }
          }
          if ( check_line_items == false ) {
            seller_global_arr[product_json[i]['id']] = 'false';
          }
        }
      }

      //
      // OLD ORDERS
      //
      if ( $("body").hasClass("page-current-orders") ) {
        for (var i = 0; i < product_json.length; i++) {
          var pco_check = false;
          if ( product_json[i]['fulfillment_status'] == 'fulfilled' || product_json[i]['financial_status'] == "voided" || product_json[i]['financial_status'] == "refunded" ) {
            pco_check = true;
          } else {
            seller_global_arr[product_json[i]['id']] = 'false';
          }
          if ( product_json[i]['closed_at'] && product_json[i]['closed_at'] != 'null' ) {
            pco_check = true;
          }
          if ( product_json[i]['cancelled_at'] && product_json[i]['cancelled_at'] != 'null' )  {
            pco_check = true;
          }
          if (pco_check && product_json[i] != 'false'  ) {
            seller_global_arr[product_json[i]['id']] = product_json[i];
            // all separate orders
            seller_global_Items_arr[seller_orders_Products_count] = product_json[i];
            seller_orders_Products_count++;
          }
        } 
      }

      //
      // CURRENT ORDERS
      //
      
      if ( $("body").hasClass("page-current-orders") ) {
        for (var i = 0; i < product_json.length; i++) {
          var pco_check = false;
          if ( product_json[i]['fulfillment_status'] != 'fulfilled' && product_json[i]['financial_status'] != "voided" && product_json[i]['financial_status'] != "refunded" ) {
            pco_check = true;
          } else {
            seller_global_arr[product_json[i]['id']] = 'false';
          }
          if ( product_json[i]['closed_at'] && product_json[i]['closed_at'] != 'null' ) {
            pco_check = false;
            seller_global_arr[product_json[i]['id']] = 'false';
          }
          if ( product_json[i]['cancelled_at'] && product_json[i]['cancelled_at'] != 'null' )  {
            pco_check = false;
            seller_global_arr[product_json[i]['id']] = 'false';
          }
          if (pco_check && product_json[i] != 'false'  ) {
            seller_global_arr[product_json[i]['id']] = product_json[i];
            // all separate orders
            seller_global_Items_arr[seller_orders_Products_count] = product_json[i];
            seller_orders_Products_count++;
          }
        }
      }
      
      if ( $(".order_id_list_js_item").length <= 0 ) {
        for (var i = 0; i < seller_global_Items_arr.length; i++) {
          if ( i < 10) {
            var line_item_Order = seller_global_Items_arr[i];
            seller_acc_old_new_orders__HTML(line_item_Order);
          }
        }
        seller_img_prod_load ();
      }
      

      setTimeout(function () {
        if (seller_global_Orders_list_work.length) {
          seller_acc_old_new_orders();
          func_simplePagination_item();
          $(".seller_latest_products_sold_items__Paginations").addClass("loading");
        } else {
          $('.acc_orders_list_all .table-wrapper table tfoot tr.tr-loading').hide();
          // start pagination
          func_simplePagination_item();
          $(".seller_latest_products_sold_items__Paginations").removeClass("loading");
        }
      }, 2000);
    }
  });
}


function seller_acc_old_new_orders__HTML (line_item_Order) {

    var id = line_item_Order['id'];
    if($('.acc_orders_list_all table tbody tr[data-order-id="'+id+'"]').length) return;
    //if(globalAddedOrders.includes(line_item_Order.id)) return;
    //globalAddedOrders.push(line_item_Order.id);

    var check_go = true;
    if ( $(".seller_orders_item[data-order_id='"+id+"']").length ) {
      check_go = false;
    }

    if (check_go && line_item_Order != 'false') {

      var html = $("script#script_order_id_list_2_js").html();
      // ORDER ID 
      html = html.replace( /_ORDER_ID_/g , id);
      // ORDER NAME
      html = html.replace( /_ORDER_NAME_/g ,  line_item_Order['name']);
      // DATE 
      var var_date = line_item_Order['created_at'].split("T");
      var_date = var_date[0].split("-");
      var monthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var_date = monthNames[Number(var_date[1])] + ' ' + var_date[2] + ', ' + var_date[0];
      html = html.replace("_DATE_", var_date).replace("_DATE_", var_date);
      // financial_status
      html = html.replace( /_financial_status_/g ,  line_item_Order['financial_status']);
      
      // _fulfillment_statusText_
      if ( line_item_Order['fulfillment_status'] == 'null' || line_item_Order['fulfillment_status'] == null ) {
        if  ( line_item_Order['financial_status'] == "voided" ) {
          html = html.replace( /_fulfillment_statusText_/g ,  'Voided');
        } else if  ( line_item_Order['financial_status'] != null && line_item_Order['financial_status'] == "refunded" ) {
          html = html.replace( /_fulfillment_statusText_/g ,  'Refunded');
        } else if  ( line_item_Order['cancelled_at'] != null && line_item_Order['cancelled_at'] != "null" ) {
          html = html.replace( /_fulfillment_statusText_/g ,  'Canceled'); 
          html = html.replace( /_order_cancel_/g ,  'canceled'); 
        }  else if  ( line_item_Order['closed_at'] != null && line_item_Order['closed_at'] != "null" ) {
          html = html.replace( /_fulfillment_statusText_/g ,  'Archived');
          html = html.replace( /_order_cancel_/g ,  'archived'); 
        } else {
          html = html.replace( /_fulfillment_statusText_/g ,  'Not done');
        }
      } else {
        html = html.replace( /_fulfillment_statusText_/g ,  line_item_Order['fulfillment_status']);
      }

      lineItemsLength = 0;
      for(let i = 0; i < line_item_Order['line_items'].length; i++) {
        lineItemsLength += (line_item_Order['line_items'][i]?.quantity || 0);
      }
      html = html.replace( /_order_items_count_/g ,  lineItemsLength);

      // _SIMPLE_PRICE_
      var total_price = line_item_Order['total_price'];
      total_price = '$' + total_price + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((total_price * window.theme.additional_price_rate)) + '</span>';
      html = html.replace( /_order_totla_price_/g ,  total_price);

      
      $('.acc_orders_list_all table.table tbody').append(html);

      /*
      for (var i = 0; i < line_item_Order['line_items'].length; i++) {
        if (line_item_Order['line_items'][i] != 'false') {
          var html_item = $("script#script_order_id_list_2_js__item").html();


          var line_item = line_item_Order['line_items'][i];
          // PRODUCT_ID
          html_item = html_item.replace( /_PRODUCT_ID_/g , line_item.product_id);
          // ORDER ID 
          html_item = html_item.replace( /_ORDER_ID_/g , id);
          // ORDER NAME
          html_item = html_item.replace( /_ORDER_NAME_/g ,  line_item_Order['name']);
          // TITLE 
          html_item = html_item.replace( /_TITLE_/g , line_item.title);
          // financial_status
          html_item = html_item.replace( /_financial_status_/g ,  line_item_Order['financial_status']);
          // fulfillment_status - TEXT
          html_item = html_item.replace( /_fulfillment_status_/g ,  line_item.fulfillment_status);

          // _fulfillment_statusText_
          if ( line_item.fulfillment_status == 'null' || line_item.fulfillment_status == null ) {
            if  ( line_item_Order['financial_status'] == "voided" ) {
              html_item = html_item.replace( /_fulfillment_statusText_/g ,  'Voided');
            } else if  ( line_item_Order['financial_status'] != null && line_item_Order['financial_status'] == "refunded" ) {
              html_item = html_item.replace( /_fulfillment_statusText_/g ,  'Refunded');
            } else if  ( line_item_Order['cancelled_at'] != null && line_item_Order['cancelled_at'] != "null" ) {
              html_item = html_item.replace( /_fulfillment_statusText_/g ,  'Canceled'); 
              html_item = html_item.replace( /_order_cancel_/g ,  'canceled'); 
            }  else if  ( line_item_Order['closed_at'] != null && line_item_Order['closed_at'] != "null" ) {
              html_item = html_item.replace( /_fulfillment_statusText_/g ,  'Archived');
              html_item = html_item.replace( /_order_cancel_/g ,  'archived'); 
            } else {
              html_item = html_item.replace( /_fulfillment_statusText_/g ,  'Not done');
            }
          } else {
            html_item = html_item.replace( /_fulfillment_statusText_/g ,  line_item.fulfillment_status);
          }
          html_item = html_item.replace( /_order_cancel_/g ,  ''); 
          
          // DATE 
          var var_date = line_item_Order['created_at'].split("T");
          var_date = var_date[0].split("-");
          var monthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          var_date = monthNames[Number(var_date[1])] + ' ' + var_date[2] + ', ' + var_date[0];
          html_item = html_item.replace("_DATE_", var_date).replace("_DATE_", var_date);
          // PRICE 
          var price = '$' + line_item.price.replace(".00", '') + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((line_item.price * window.theme.additional_price_rate)) + '</span>';
          html_item = html_item.replace( /__PRICE__/g , price);
          // _SIMPLE_PRICE_
          html_item = html_item.replace( /__SIMPLE_PRICE__/g , line_item.price); 


          $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js").append(html_item);


        }
      }
      */

      
      // STATUS
      /*
      if (  $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-cancel='canceled']").length ) {
        var status = "Canceled";
        var status_text = "Canceled";
      } else if (  $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-cancel='archived']").length ) {
        var status = "Archived";
        var status_text = "Archived";
      } else if ( $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-status='null']").length ) {
        if  ( $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-financial_status='voided']").length ) {
          var status_text = "Voided";
        } else if  ( $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-financial_status='refunded']").length ) {
          var status_text = "Refunded";
        } else {
          var status_text = "Not done";
        }
        var status = "Null";
      } else if (  $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-status='partial']").length ) {
        var status = "Partial";
        var status_text = "Partial";
      } else if (  $(".seller_orders_item[data-order_id='"+id+"'] .seller_latest_products_sold_items_js .status[data-status='restocked']").length ) {
        var status = "Restocked";
        var status_text = "Restocked";
      } else  {
        var status = "Fulfilled";
        var status_text = "Fulfilled";
      }
      $(".seller_orders_item[data-order_id='"+id+"'] .top_btn .status").text(status_text);
      $(".seller_orders_item[data-order_id='"+id+"'] .top_btn .status").attr("data-status", status);
      */
      
    }

  /*
  setTimeout(function () {
    seller_img_prod_load ();
  }, 1000);
  */

}





// =====================================================================================================================
//   SELLER ACCOUNT   -  PAGE ORDER DETAILS
// =====================================================================================================================

$(document).ready(function () {
  if ($(".order_details_js").length) {
    var order_id = window.location.href.split("?id=");
    order_id = order_id[1].split("#");
    order_id = order_id[0];

    jQuery.ajax({
      type: 'GET',
      url: 'http://serg-test.site/api_JUM3a/jum3a_get_orders.php?orders=' + order_id + '&id=' + window.theme.customerId,
      data: {},
      complete: function (data) {

        product_json = JSON.parse(data.responseText);
        seller_order_details__HTML(product_json[0]);


      }
    });
  }
});
function seller_order_details__HTML(product_json) {
  // NAME
  $('.od_order_name_js').html(product_json['name']);

  // DATE
  var var_date = product_json['created_at'].split("T");
  var_date = var_date[0].split("-");
  var monthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var_date = monthNames[Number(var_date[1])] + ' ' + var_date[2] + ', ' + var_date[0];
  $('.od_date_js').html(var_date);

  // financial_status
  var var_financial_status = product_json['financial_status'];
  var_financial_status = var_financial_status[0].toUpperCase() + var_financial_status.slice(1);
  var_financial_status = var_financial_status.replace("_", "");
  $('.od_payment_status_js').html(var_financial_status);

  // ITEMS
  for (var i = 0; i < product_json['line_items'].length; i++) {
    if (product_json['line_items'][i] != 'false') {
      var price = '$' + product_json['line_items'][i].price.replace(".00", '') + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((product_json['line_items'][i].price * window.theme.additional_price_rate)) + '</span>';
      $(".od_items_js").prepend('<div class="item" data-price="' + product_json['line_items'][i].price + '" data-qty="' + product_json['line_items'][i].quantity + '"><div class="title">' + product_json['line_items'][i].name + ' (x' + product_json['line_items'][i].quantity + ')</div><div class="price">' + price + '</div></div>');
    }
  }

  // TOTAL PRICE
  if (product_json['line_items'].length == 1) {
    var price = '$' + product_json['line_items'][0].price.replace(".00", '') + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((product_json['line_items'][0].price * window.theme.additional_price_rate)) + '</span>';
    $(".od_total_js").html(price);
    $(".od_order_price_js").html(price);
    $(".od_total_price_js").html(price);
  } else {
    var item_price = 0;
    $(".od_items_js .item").each(function () {
      var current_item_price = Number($(this).attr('data-price'));
      var qty = Number($(this).attr('data-qty'));
      item_price = item_price + (current_item_price * qty);
    });
    var price = '$' + item_price + '<span class="price_iqd"><span id="currency_symbol">ع.د</span>' + addCommas((item_price * window.theme.additional_price_rate)) + '</span>';

    $(".od_total_js").html(price);
    $(".od_order_price_js").html(price);
    $(".od_total_price_js").html(price);
  }

  // SHIPPING
  for (var i = 0; i < product_json['shipping_lines'].length; i++) {
    if (i == 0) {
      var shipping_lines = product_json['shipping_lines'][i].title;
    } else {
      shipping_lines = shipping_lines + ',' + product_json['shipping_lines'][i].title;
    }
  }
  $(".od_shipment_details_js").html(shipping_lines);


  // PAYMENT METHOD
  for (var i = 0; i < product_json['payment_gateway_names'].length; i++) {
    if (i == 0) {
      var payment_gateway_names = product_json['payment_gateway_names'][i];
    } else {
      payment_gateway_names = payment_gateway_names + ',' + product_json['payment_gateway_names'][i];
    }
  }
  $(".od_payment_method_js").html(payment_gateway_names);

  // ADDRESS
  var billing_address = product_json['billing_address']["address1"] + ', ';
  billing_address += product_json['billing_address']["address2"] + ', ';
  billing_address += product_json['billing_address']["city"] + '<br>';
  if (product_json['billing_address']["company"]) {
    billing_address += product_json['billing_address']["company"] + '<br>';
  }
  billing_address += product_json['billing_address']["country"] + ', ';
  billing_address += product_json['billing_address']["first_name"] + ', ';
  billing_address += product_json['billing_address']["last_name"] + ', ';
  billing_address += product_json['billing_address']["phone"] + ', ';
  if (product_json['billing_address']["zip"]) {
    billing_address += product_json['billing_address']["zip"] + ', ';
  }
  $(".od_billing_address_js").html(billing_address);

  setTimeout(function () {
    seller_img_prod_load ();
  }, 1000);
}




// =====================================================================================================================
//   SELLER ACCOUNT   -  PAGE ORDER DETAILS
// =====================================================================================================================

var glob_seller_img_prod_load = [];
function seller_img_prod_load () {
  var ids;
  var check_i = 0;


  $('img[data-img_prod_load]').each( function () {
    var the_id =  $(this).attr("data-img_prod_load");
    if ( glob_seller_img_prod_load[the_id] ) {
      var var_img = glob_seller_img_prod_load[the_id]['images'][0].replace('.jpg', '_200x.jpg').replace('.JPG', '_200x.JPG').replace('.jpeg', '_200x.jpeg').replace('.JPEG', '_200x.JPEG').replace('.png', '_200x.png').replace('.PNG', '_200x.PNG').replace('.gif', '_200x.gif').replace('.GIF', '_200x.GIF');
      $(this).attr("src",  var_img);
      $(this).addClass("ready");
    }
  });
  

  $('img[data-img_prod_load]:not(.ready)').each( function () {
    if (check_i < 250) {
      if (check_i == 0) {
        ids =  $(this).attr("data-img_prod_load");
      } else {
        ids = ids + ',' + $(this).attr("data-img_prod_load");
      }
      $(this).addClass("ready");
    }
    check_i++;
  });
  
  if (ids) {
    jQuery.ajax({
      type: 'GET',
      url: 'http://serg-test.site/api_JUM3a/jum3a_get_prod_image.php?products=' + ids + '&id=' + window.theme.customerId,
      data: {},
      complete: function (data) {

        product_json = JSON.parse(data.responseText);
        for (var i = 0; i < product_json.length; i++) {
          glob_seller_img_prod_load[product_json[i]['id']] = product_json[i];
        }

        
        $('img.ready[data-img_prod_load]').each( function () {
          var the_id =  $(this).attr("data-img_prod_load");
          if ( glob_seller_img_prod_load[the_id] ) {
            var var_img = glob_seller_img_prod_load[the_id]['images'][0].replace('.jpg', '_200x.jpg').replace('.JPG', '_200x.JPG').replace('.jpeg', '_200x.jpeg').replace('.JPEG', '_200x.JPEG').replace('.png', '_200x.png').replace('.PNG', '_200x.PNG').replace('.gif', '_200x.gif').replace('.GIF', '_200x.GIF');
            $(this).attr("src",  var_img);
          }
        });

        setTimeout(function () {
          if ($("img[data-img_prod_load]:not(.ready)").length) {
            seller_img_prod_load();
          }
        }, 2000);
      }
    });
  }
}


// =====================================================================================================================
// PRODUCT PAGE - OPEN RPE ORDER WINDOW
// =====================================================================================================================

$(document).ready(function () {
  setTimeout(function () {
    if ( window.location.href.indexOf('pre_order_js') !== -1  && $(".btn-notify-me").length  ) {
      function func_pre_order_js () {
        if ( $(".BIS_trigger").length ) {
          $('.BIS_trigger').trigger('click');
        } else {
          setTimeout(function () {
            func_pre_order_js ();
          }, 2000);
        }
      }
      func_pre_order_js ();
    }
  }, 2000);
});


// =====================================================================================================================
// LAZY LOAD PRODUCT INFO
// =====================================================================================================================
$(document).ready(function () {
  
  setTimeout(function () {
    $("[data-prod-src]").each(  function() {
      var data = $(this).attr("data-prod-src");
      $(this).attr("src", data);
    });
    
    document.querySelectorAll('.rte iframe[data-prod-src]').forEach(function (iframe) {
      // We scope the wrapping only for YouTube and Vimeo
      if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
        iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + '</div>';

        // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
        iframe.src = iframe.src;
      }
    });
  }, 3000);
});


// =====================================================================================================================
//   PRODUCT OPTIONS -- METFIELD -- Similar-products
// =====================================================================================================================
function metafield_similar_products () {
  $(".prod_item_swatch").removeClass("hide");

  if ( $(".metafield_similar_products_2_js").length ) {
    var option_1 = $(".metafield_similar_products_1_js .prod_item_swatch.active[data-option_1]").attr('data-option_1');
    var option_2 = $(".metafield_similar_products_2_js .prod_item_swatch.active[data-option_2]").attr('data-option_2');
    $(".metafield_similar_products_1_js .prod_item_swatch:not([data-option_2='"+option_2+"'])").hide();
    $(".metafield_similar_products_2_js .prod_item_swatch:not([data-option_1='"+option_1+"'])").hide();
    
  }
}
$(document).ready(function () {
  metafield_similar_products ();
});


// =====================================================================================================================
//   PAGE - AREA TO SELLER
// =====================================================================================================================

/*
$(document).ready(function () {
  var url = window.location.href.toLowerCase();

  if ( window.theme.customerId == null && $("body").hasClass("page-area-to-sell") && url.indexOf('customerid') !== -1 ) {
    var url = url.split("?customerId=");
    var customer_id = url[1];
    var lang = $("html").attr("lang");


    jQuery.ajax({
      type: 'GET',
      url: 'http://serg-test.site/api_JUM3a/jum3a_get_areas.php?lang=' + lang + '&id=' + customer_id,
      data: {},
      complete: function (data) {
        data_json = JSON.parse(data.responseText);

        var items = data_json.value.split(",");
        for (var i = 0; i < items.length; i++) {
          $(".ul_area_to_sell_all_js").append('<li>'+items[i]+'</li>');
        }

      }
    });

  }
});
*/


// =====================================================================================================================
//   COLLECTION ADD BANNERS
// =====================================================================================================================
function add_coll_banners () {
  $(".coll_banner_all").remove();


  for (var i = 1; i < 9; i++) {
    
    if ( typeof(banners_data) != undefined && banners_data[i] ) {
      var data = banners_data[i];
      var media = '';
      // LINK
      var link = '';
      if ( data['link'] ) {
        link = 'href="'+data['link']+'"';
      }
      if ( data['video'] && data['video'] != 'false' ) {
        // VIDEO
        media = '<div class="coll_banner_video"><iframe  src="https://www.youtube.com/embed/'+youtube_parser(data["video"])+'" frameborder="0" allowfullscreen class="lazyload" data-src="https://www.youtube.com/embed/'+youtube_parser(data["video"])+'"></iframe></div>';
      } else {
        // IMAGE
        var img_arr = data['image'].split(",");
        var img_html = '<img class="slideshow__image lazyload image--fade-in" alt="" data-src="_URL_" _SRC_ data-widths="[800,900,1000,1100,1200,1300,1400,1600,1800]" data-sizes="auto">'
        if ( img_arr.length > 1 ) {
          var media = '<div class="coll_banner_slider coll_banner_slider_js">';
        } else {
          var media = '<div class="coll_banner_slider">';
        }
          for (var q = 0; q < img_arr.length; q++) {
            var url = img_arr[q].replace('.jpg', '_{width}x.jpg').replace('.JPG', '_{width}x.JPG').replace('.jpeg', '_{width}x.jpeg').replace('.JPEG', '_{width}x.JPEG').replace('.png', '_{width}x.png').replace('.PNG', '_{width}x.PNG').replace('.gif', '_{width}x.gif').replace('.GIF', '_{width}x.GIF');
            if ( q == 0) {
              var url_mini = 'src="'+url.replace('_{width}x', '_10x')+'"';
              media += '<div class="coll_banner_slider_item"><a '+link+'>'+img_html.replace("_URL_", url).replace("_SRC_", url_mini)+'</a></div>';
            } else {
              media += '<div class="coll_banner_slider_item"><a '+link+'>'+img_html.replace("_URL_", url).replace("_SRC_", '')+'</a></div>';
            }
          }
          media += '</div>'
      }
      var title = '';
      if ( data['title'] ) {
        title = '<div class="coll_banner_title"><a '+link+'>'+data['title']+'</a></div>';
      }
      // LINK TEXT
      var link_text = '';
      if ( data['link_text'] && data['link'] ) {
        link_text = '<div class="coll_banner_link_text"><a '+link+'>'+data['link_text']+'</a></div>';
      }


      var html = '<div class="coll_banner_all" data-item="'+i+'">'+
                    media+
                    '<div class="coll_banner_info">'+
                      title+
                      link_text+
                    '</div>'+
                  '</div>';

      var push_num = $(window).width() > 1000 ? 8 : 6;
      var prod_item_length = $(".boost-pfs-filter-products .product-item").length;
      if ( (push_num*i) <= prod_item_length  ) {
        $(".boost-pfs-filter-products .product-item").eq( push_num*i-1 ).after(html);
      } else if ( push_num > prod_item_length && $(".coll_banner_all").length <= 0 ) {
        $(".boost-pfs-filter-products .product-item").eq( prod_item_length-1 ).after(html);
      }
    }
    

    setTimeout(function () {
      if(typeof flickity != undefined && typeof flickity != 'undefined') {
        $('.coll_banner_slider_js').flickity({
          // options
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          wrapAround: true
        });
      }
    }, 3000);
  }

}


// =====================================================================================================================
//   YOUTUBE YRL ID PARSER
// =====================================================================================================================
function youtube_parser(url){
  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  var match = url.match(regExp);
  if (match && match[2].length == 11) {
    return match[2];
  } else {
    //error
  }
}





// =====================================================================================================================
//   COLLECTION BANNERS
// =====================================================================================================================
$('body').on('click', '.page_careers_button_apply', function() {
  $(".page_careers_page_1_js").hide();
  $('.page_careers_page_2_js').fadeIn();
});
$('body').on('click', '.page_careers_button_back', function() {
  $(".page_careers_page_1_js").fadeIn();
  $('.page_careers_page_2_js').hide();
});




// =====================================================================================================================
//   HEADER SELECT CYRRESY
// =====================================================================================================================

$("body").on("click touchstart", ".header_currency_switcher_item", function() {
  $(".mob_lvl_a_item.currency_js").removeClass("active");
  if ( $(this).hasClass("usd") ) {
    localStorage.removeItem('js_currency');
    $("body").removeClass("currency_iqd");
    $(".mob_lvl_a_item.currency_js.usd").addClass("active");
  } else {
    localStorage.setItem('js_currency', 'iqd');
    $("body").addClass("currency_iqd");
    $(".mob_lvl_a_item.currency_js.iqd").addClass("active");
  }
});





// =====================================================================================================================
//   PRODUCT PAGE OPEN SHARE WINDOW
// =====================================================================================================================
$("body").on("click", ".prod_share_button", function() {
  $(".share2_popUp").addClass("active");
})
$("body").on("click", ".share2_popUp_close_js", function() {
  $(".share2_popUp").removeClass("active");
})


setTimeout(function () {
  if(typeof flickity != undefined && typeof flickity != 'undefined') {
    $('.brands_items_slider').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      wrapAround: true
    });
  }
}, 2000);
// =====================================================================================================================
//   MENU ADD FILTER CITY
// =====================================================================================================================
/*
$('body').on('click', 'a[href*="/collections/"]', function(e) {
  e.preventDefault();
  
  var url = $(this).attr("href");
  if ( url.indexOf('products') > -1 ) {
    location.href = url;
  } else if ( url.indexOf('?') > -1 && localStorage.getItem('js_user_city') ) {
    location.href = url + '!!!!!!!!!!!!!!!!!!!!' + localStorage.getItem('js_user_city');
  } else if ( localStorage.getItem('js_user_city') )  {
    location.href = url + '!!!!!!!!!!!!!!!!!!!!' + localStorage.getItem('js_user_city');
  } else {
    location.href = url;
  }
  
});
*/


// Product page. Replacement the Reviews section


$(document).ready(function() {
  let reviewsSection = $('.product-block-list__item--reviews');
  let windowWidth = $(window).width();
  if(reviewsSection.length) {
    if(windowWidth > 640) {
      reviewsSection.removeClass('hide');
      reviewsSection.prependTo('.product_gallery_info_wrapper ~ .mobile__hide');
    }
    else $('.product-form__info-list .product_trust.desktop__hide').after(reviewsSection);
  }
});


// Loyalty page

$(function() {
  $('.lion-header__nav .lion-header__nav-link').on('click', function() {
    let redirectTo = $(this).data('redirect');
    let headerHeight = 0;
    if($('header.header.enable_sticky_header').length) {
      headerHeight = $('header.header.enable_sticky_header').outerHeight();
    }
    if(redirectTo) {
      $('h3[data-redirect]').each(function() {
        let curData = $(this).data('redirect');
        if(redirectTo == curData) {
          $([document.documentElement, document.body]).animate({
            scrollTop: ($(this).offset().top - headerHeight)
          }, 1000);
          return false;
        }
      });
    }
    return false;
  });
});


// Customer area | Change Customer info

$(function() {
  $('.customer-info-form .form .btn').on('click', function(e) {
    e.preventDefault();
    let fetchedElStyles = '';
    let form = $(this).closest('.form');
    let urlString = '?';
    if($(this).hasClass('update-info')) {
      let fields = $(this).closest('.form').find('input');
      fields.each(function() {
        let fieldName = $(this).data('field');
        let fieldValue = encodeURIComponent($(this).val());
        urlString += fieldName + '=' + fieldValue +'&';
      });
    }
    else {
      let input = false;
      if($(this).hasClass('update-password')) {
        input = $(this).closest('.form').find('#customer-password-change');
        fetchedElStyles = ' style="order: 2;" ';
      }
      else if($(this).hasClass('update-phone')) {
        input = $(this).closest('.form').find('#customer-phone-change');
        fetchedElStyles = ' style="order: 4;" ';
      }
      if(input) {
        let fieldName = input.data('field');
        let fieldValue = encodeURIComponent(input.val());
        urlString += fieldName + '=' + fieldValue + '&';
      }
    }
    form?.find('.fetch-info').remove();
    if(urlString != '?') {
      let customerId = $('.content-area').data('customer-id');
      urlString += 'customer-id=' + customerId;
      const start = async function(a, b) {
        let url = 'https://insales-api.info/jum3a/customer-info-change.php' + urlString;
        let response = await fetch(url);
        if (response.ok) { 
          let json = await response?.json();
          if(json && json.customer) {
            let fetchedText = 'Updated successfully';
            if($('html').attr('lang') == 'ar') fetchedText = 'تم التحديث بنجاح';
            form.append('<div class="fetch-info success" ' + fetchedElStyles + '>'+fetchedText+'</div>');
          }
          else if(json && json.errors) {
            let fetchedText = '';
            for (let [key, value] of Object.entries(json.errors)) {
              fetchedText += `${key}: ${value}<br>`;
            }
            form.append('<div class="fetch-info error" ' + fetchedElStyles + '>'+fetchedText+'</div>');
          }
          else {
            let fetchedText = 'Some error occurred';
            if($('html').attr('lang') == 'ar') fetchedText = 'حدث خطأ ما';
            form.append('<div class="fetch-info error" ' + fetchedElStyles + '>'+fetchedText+'</div>');
          }
        } else {
          alert("Error: " + response.status);
        }
      }
      start();
    }
    return false;
  });
});
